import React from 'react'
import { Link } from 'react-router-dom'
import { Space, Typography } from 'antd'
import { get, map } from 'lodash'
import PropTypes from 'prop-types'

import { APP_ROUTES, METADATA_TYPES } from '../../constants'

const MetadataTreeErrors = ({ errors }) =>
  map(errors, ({ id, name, type }, index) => (
    <Typography.Paragraph key={index}>
      <Space>
        <Typography.Text strong>{name}</Typography.Text>

        <Typography.Text>
          affects {get(METADATA_TYPES, `${type}.labelSingular`)}:
        </Typography.Text>

        <Link
          to={`${get(
            APP_ROUTES,
            `${get(METADATA_TYPES, `${type}.value`)}.link`,
          )}/${id}`}
        >
          {name}
        </Link>
      </Space>
    </Typography.Paragraph>
  ))

MetadataTreeErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default MetadataTreeErrors
